import { httpService } from '@/api/v1/http.service'
import useDownload, { type DownloadParams } from '@/hooks/useDownload'
import { parseColumnsToFetchKeys } from '@/utils/parse-columns-to-fetch-keys'

import type { CoursesGroupsParams } from '../queries/useCoursesGroups'

type Params = DownloadParams & CoursesGroupsParams

const useCoursesGroupsDownload = (coursesDownloadParams: Params) => {
  const columns = coursesDownloadParams.columnsKey?.filter(
    columnKey => columnKey !== 'gradebook'
  )

  return useDownload({
    fileName: 'courses',
    requestParams: coursesDownloadParams,
    downloadMutation: (params: Params) =>
      httpService.panel.panelLessonsGroupsList(
        {
          id: params.ids,
          student_id: params.studentsId,
          class_id: params.classesId,
          course_id: params.coursesId,
          semester_id: params.semester,
          teacher_or_co_teacher_id: params.teacherOrCoTeacherId,
          tutor_id: params.tutorId,
          ordering: 'course__name,name',
          format: params.format,
          fetchKeys: parseColumnsToFetchKeys(columns, params.format)
        },
        { format: 'blob' }
      ) as unknown as Promise<File>
  })
}

export default useCoursesGroupsDownload
